<template>
  <div
    class="pagination"
    role="navigation"
    :aria-label="$t('productlist.page') + ' ' + currentPage + ' ' + $t('productlist.page.of') + ' ' + pagesCount"
  >
    <div
      class="pagination__button-container"
      :class="{
        'pagination__button-container--show-page-buttons': showPageButtons
      }"
    >
      <span
        class="pagination__button pagination__button--prev"
        :class="{'pagination__button--disabled': currentPage === 1}"
        @click="prevButtonClickHandler"
        @keydown.enter.space.prevent="prevButtonClickHandler"
        v-if="showPageButtons"
        role="button"
        tabindex="0"
        :aria-label="$t('pagination.prev_page')"
      >
        {{ $t('pager.prev_page') }}
      </span>
      <div class="pagination__pages">
        <span class="pagination__label">{{ $t('productlist.page') }}</span>
        <div
          class="pagination__wrapper"
          :class="{
            'pagination__wrapper--disabled': pagesCount === 1
          }"
        >
          <select-vue
            class="paging__select select--formless"
            :class="{
              'pagination__select--disabled': pagesCount === 1
            }"
            @input="selectInputHandler"
            name="sort"
            :options="options"
            :initial-value="currentPage"
            :disabled="pagesCount === 1"
            ref="select"
          />
        </div>
        <span class="pagination__label">{{ $t('productlist.page.of') }}</span>
        <span class="pagination__pages-count">{{ pagesCount }}</span>
      </div>
      <span
        class="pagination__button pagination__button--next"
        :class="{'pagination__button--disabled': currentPage === pagesCount}"
        @click="nextButtonClickHandler"
        @keydown.enter.space.prevent="nextButtonClickHandler"
        v-if="showPageButtons"
        role="button"
        tabindex="0"
        :aria-label="$t('pagination.next_page')"
      >
        {{ $t('pager.next_page') }}
      </span>
    </div>
  </div>
</template>

<script>
  import SelectVue from '../../../bps/components/select/select';
  import {usePlaceholder} from '../../utilities/vueMixins/placeholderMixin/placeholder';

  const Pagination = {
    name: 'pagination',
    components: {
      SelectVue
    },
    props: {
      name: String,
      pagesCount: {
        type: Number,
        default: 1
      },
      page: {
        type: Number,
        default: 1
      },
      showPageButtons: {
        type: Boolean,
        default: true
      },
      placeholderElement: {
        type: String,
        default: 'pagination'
      }
    },
    emits: ['change'],
    mounted() {
      usePlaceholder(this.placeholderElement);
    },
    computed: {
      currentPage: {
        get() {
          return this.page;
        },
        set(data) {
          this.$emit('change', data);
        }
      },
      options() {
        const arr = [];
        for (let item = 1; item <= this.pagesCount; item++) {
          arr.push({value: item, label: item});
        }

        return arr;
      }
    },
    watch: {
      page(data) {
        if (this.$refs.select.getValue() !== data) {
          this.$refs.select.setValue(data);
        }
      }
    },
    methods: {
      selectInputHandler(value) {
        if (value !== this.currentPage) {
          this.currentPage = value;
        }
      },
      prevButtonClickHandler() {
        if (this.currentPage !== 1) {
          this.goToPrevPage();
        }
      },
      nextButtonClickHandler() {
        if (this.currentPage !== this.pagesCount) {
          this.goToNextPage();
        }
      },
      goToPrevPage() {
        this.currentPage -= 1;
      },
      goToNextPage() {
        this.currentPage += 1;
      }
    }
  };

  export default Pagination;
</script>
